"use strict";

exports.__esModule = true;
var _AuditLogGridConfig = require("./AuditLogGridConfig");
Object.keys(_AuditLogGridConfig).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AuditLogGridConfig[key]) return;
  exports[key] = _AuditLogGridConfig[key];
});
var _AuditLogGrid = require("./AuditLogGrid");
Object.keys(_AuditLogGrid).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AuditLogGrid[key]) return;
  exports[key] = _AuditLogGrid[key];
});